<style scoped>
.checkin_information_data_top {
  width: 100%;
  height: 69px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px 0 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #e8e8e8;
}
.checkin_information_data_date {
  display: flex;
  align-items: center;
}
.checkin_information_shortcuts {
  display: flex;
  align-items: center;
  width: 115px;
  justify-content: space-between;
  margin-right: 30px;
}
.checkin_information_shortcuts_sing {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}
.currentSelect {
  color: #0058ff;
}
.checkin_information_data_dept {
  width: 200px;
  height: 32px;
}
::v-deep .checkin_information_data_dept .el-input {
  height: 100%;
}
::v-deep .checkin_information_data_dept .el-input__inner {
  height: 100%;
}
.checkin_information_date {
  width: 256px !important;
  height: 32px;
}
::v-deep .el-date-editor .el-range__icon {
  line-height: 28px !important;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: 22px !important;
}
</style>

<template>
  <div class="checkin_information_data_top">
    <el-select
        v-model="queryForm.deptId"
        clearable
        placeholder="请选择"
        @change="handleChangeDept"
        class="checkin_information_data_dept"
    >
      <el-option
          v-for="item in depteOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id">
      </el-option>
    </el-select>
    <div class="checkin_information_data_date">
      <div class="checkin_information_shortcuts">
        <div
            v-for="item in dateList"
            @click="switchTab(item.value)"
            :class="['checkin_information_shortcuts_sing', item.value == currentDate ? 'currentSelect' : '',]">
          {{ item.label }}
        </div>
      </div>
      <el-date-picker
          class="checkin_information_date"
          v-model="daterange"
          type="daterange"
          range-separator="-"
          @change="handleChangeDate"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
    </div>
  </div>
</template>


<script>
import {queryDeptmentList} from "@/api/server/deptment";
export default {
  components: {},
  data() {
    return {
      queryForm:{
        deptId: "",
        startTime: '',
        endTime: ''
      },
      daterange:[],
      depteOptions:[],
      dateList: [
        {
          value: 2,
          label: "本周",
        },
        {
          value: 3,
          label: "本月",
        },
      ],
      currentDate: 2,
    };
  },
  created() {

  },
  async mounted() {
    await this.getDepartent();
    let weekRange = this.getWeekRange();
    this.queryForm.startTime = weekRange?.startTime || '';
    this.queryForm.endTime = weekRange?.endTime || '';
    // this.queryForm.deptId = this.depteOptions[0]?.id;
    // this.queryForm.deptName = this.depteOptions[0]?.name;
    this.handleEmit();
  },
  methods: {
    async getDepartent() {
      const {code,data} = await queryDeptmentList();
      if(code == 200){
        this.depteOptions = data;
      }
    },
    handleEmit(){
      if(this.queryForm.deptId){
        const deptId = this.queryForm.deptId;
        this.queryForm.deptName = this.depteOptions?.filter((item) => item.id == deptId)[0]?.name;
      }
      this.$emit("query", this.queryForm);
    },
    handleChangeDept(){
      this.handleEmit();
    },
    switchTab(value) {
      switch ( value){
        case 2:
          let weekRange = this.getWeekRange();
          this.daterange = [];
          this.queryForm.startTime = weekRange?.startTime;
          this.queryForm.endTime = weekRange?.endTime;
          this.currentDate = 2;
          break;
        case 3:
          let monthToDateRange = this.getMonthToDateRange();
          this.daterange = [];
          this.queryForm.startTime = monthToDateRange?.startTime;
          this.queryForm.endTime = monthToDateRange?.endTime;
          this.currentDate = 3;
          break;
        default:
          this.daterange = [];
          this.currentDate = null;
      }
      this.handleEmit();
    },
    handleChangeDate(date){
      if(date && date.length==2){
        this.queryForm.startTime = date[0];
        this.queryForm.endTime = date[1];
        this.currentDate = null;
        this.handleEmit();
      }else{
        this.switchTab(2);
      }
    },
    getWeekRange() {
      const now = new Date();
      const dayOfWeek = now.getDay(); // 0表示周日，1-6表示周一到周六
      const startDate = new Date(now);

      // 计算本周一的日期
      startDate.setDate(now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));

      // 格式化日期为 yyyy-MM-dd
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      return {startTime:formatDate(startDate), endTime: formatDate(now)};
    },
    getMonthToDateRange() {
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);

      // 格式化日期为 yyyy-MM-dd
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      return {startTime:formatDate(startDate), endTime: formatDate(now)};
    }
  }
};
</script>